import styled from 'styled-components'

const JustifyCenter = styled.div`
  display: flex;
  justify-content: center;
`

export default JustifyCenter
